import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const money = (v) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(v || 0);

export const imgSrc = (p) => (p?.image_path ? `${API}/files/${p.image_path}` : p?.image_url || "");

export async function downloadFile(url, filename, params) {
  const res = await api.get(url, { responseType: "blob", params });
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
}

export const applyDisc = (base, value, type) => {
  const v = Number(value) || 0;
  return type === "amount" ? Math.max(base - v, 0) : base * (1 - Math.min(v, 100) / 100);
};

export const lineNet = (l) => applyDisc(l.price * (Number(l.quantity) || 0), l.discount, l.discount_type);

export const discLabel = (v, type) => (type === "amount" ? money(v) : `%${v}`);

export function calcTotals(lines, generalDiscount, generalType = "percent") {
  let gross = 0, net = 0;
  lines.forEach((l) => { gross += l.price * (Number(l.quantity) || 0); net += lineNet(l); });
  const subtotal = applyDisc(net, generalDiscount, generalType);
  const ratio = net ? subtotal / net : 0;
  const vat = lines.reduce((s, l) => s + lineNet(l) * ratio * (l.vat / 100), 0);
  return { gross, lineDisc: gross - net, genDisc: net - subtotal, subtotal, vat, total: subtotal + vat };
}

export const norm = (v) => (v || "").toLocaleLowerCase("tr").replace(/i̇/g, "i");
export const matches = (vals, q) => { const s = norm(q); const s2 = (q || "").toLowerCase(); return !s || vals.some((v) => norm(v).includes(s) || (v || "").toLowerCase().includes(s2)); };

export const STATUSES = ["Beklemede", "Onaylandı", "Hazırlanıyor", "Teslim Edildi", "İptal"];
